<div class="ir-area ir-mask th-mask" *ngIf="inspection">
  <form class="ir-modal th-modal" (ngSubmit)="updateStatus(statusForm.value)" [formGroup]="statusForm">
    <div class="ir-modal--title">
      <div class="ir-line">
        <div class="ir-line-content">
          <span>{{ 'inspections.edit-status' | translate: inspection }}</span>
        </div>
      </div>
    </div>
    <div class="ir-modal--body has-footer ir-pv8 ir-ph8">
      <div class="ir-content--modal th-content">
        <table [permissions]="[['visible', 'manage.inspection.status']]" class="ir-modal-table">
          <tr>
            <td class="margin-big">
              <h2>
                <span>{{ 'common.status' | translate }} *</span>
              </h2>
            </td>
            <td class="margin-big">
              <div class="ir-form-group">
                <select name="status" class="ir-form-set" formControlName="status">
                  <option *ngFor="let s of statusList" [value]="s" [selected]="status == s">
                    {{ s | inspectionstatus }}
                  </option>
                </select>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
    <div class="ir-modal--footer ir-position--b th-modal--footer">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <div class="ir-btn ir-btn--big ir-btn--block th-btn-modal ir-txt--left" (click)="cancel()">
            <span>{{ 'common.cancel' | translate }}</span>
          </div>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <button
            class="ir-btn ir-btn--big ir-btn--block th-btn-modal--action ir-txt--right"
            type="submit"
            [disabled]="statusForm.invalid"
          >
            <span>{{ 'common.save-changes' | translate }}</span>
          </button>
        </div>
      </div>
    </div>
  </form>
</div>
